import { Route, Routes } from "react-router-dom";
import "./App.css";
import "./assets/css/fontStyles.css";

// GENERAL IMPORTS
import { CartProvider } from "./context/CartContext";
import { CheckoutProvider } from "./context/CheckoutContext";
import LandingPage from "./screens/customer/home/LandingPage";
import ProductListing from "./screens/customer/shop/ProductListing";
import ProductDetail from "./screens/customer/shop/ProductDetail";
import Cart from "./screens/customer/cart/Cart";
import Checkout from "./screens/customer/checkout/Checkout";
import OrderConfirmation from "./screens/customer/checkout/OrderConfirmation";
import Logout from "./screens/customer/customerPannel/logout/Logout";

// ADMIN PANNEL IMPORTS
import AdminLogin from "./components/admin/auth/AdminLogin";
import AdminSidebar from "./components/admin/adminsidebar/AdminSideBar";
import AdminMasterLayout from "./layout/AdminMasterLayout";
import AdminCategoryList from "./screens/admin/admincategorylist/AdminCategoryList";
import AdminProductList from "./screens/admin/adminproductlist/AdminProductList";
import AdminProductView from "./screens/admin/adminproductview/AdminProductView";
import CustomerList from "./screens/admin/customer/CustomerList";
import AdminDashboard from "./screens/admin/dashboard/AdminDashboard";
import AdminCouponList from "./screens/admin/adminCouponList/AdminCouponList";
import AdminOrdersList from "./screens/admin/orders/AdminOrdersList";
import AdminOrderView from "./screens/admin/orders/AdminOrderView";
import RawMaterialList from "./screens/admin/rawMaterialList/RawMaterialList";

// CUSTOMER PANNEL IMPORTS
import ProtectedRoute from "./components/customer/customerPannel/Routes/ProtectedRoute";
import { AuthProvider } from "./context/auth/AuthContext";
import CustomerMasterLayout from "./layout/customer/CustomerMasterLayout";
import CustomerDetail from "./screens/admin/customer/CustomerDetail";
import BiddingManagement from "./screens/admin/adminbiddingmanagement/BiddingManagement";
import StockAlerts from "./screens/admin/stockAlerts/StockAlerts";
import StockHistory from "./screens/admin/stockHistory/StockHistory";
import BrowseBidding from "./screens/customer/Bidding System/browseBidding/BrowseBidding";
import BiddingActivity from "./screens/customer/Bidding System/biddingActivity/BiddingActivity";
import Dashboard from "./screens/customer/customerPannel/dashboard/Dashboard";
import FAQ from "./screens/customer/customerPannel/faq/FAQ";
import HelpSupport from "./screens/customer/customerPannel/helpsupport/HelpSupport";
import Notifications from "./screens/customer/customerPannel/notifications/Notifications";
import OrderDetails from "./screens/customer/customerPannel/orderdetails/OrderDetails";
import Orders from "./screens/customer/customerPannel/orderdetails/Orders";
import Settings from "./screens/customer/customerPannel/settings/Settings";
import Wishlist from "./screens/customer/customerPannel/wishlist/Wishlist";
import FullStory from "./screens/customer/Full Story/FullStory";
import NotFound from "./screens/customer/page not found/NotFound";
import AdminSettings from "./screens/admin/adminsettings/AdminSettings";
import ContactUs from "./screens/customer/contactUs/ContactUs";
import CustomizationPannel from "./screens/customer/shop/CustomizationPannel";
import CustomRequests from "./screens/customer/customerPannel/customrequests/CustomRequests";
import AdminCustomOrderList from "./screens/admin/adminCustomOrderList/AdminCustomOrderList";
import AdminCustomOrderDetail from "./screens/admin/adminCustomOrderDetail/AdminCustomOrderDetail";
import AdminFAQ from "./screens/admin/adminFAQ/AdminFAQ";
import AdminHelp_Support from "./screens/admin/adminHelp&Support/AdminHelp_Support";
import TicketChat from "./screens/customer/customerPannel/helpsupport/TicketChat";
import AdminNotifications from "./screens/admin/adminnotifications/AdminNotifications";
import CustomOrderDetail from "./screens/customer/customerPannel/customrequests/CustomOrderDetail";
import DecorAI from "./screens/customer/decoraai/DecoraAi";
import PrivacyPolicy from "./screens/customer/privacyPolicy/PrivacyPolicy";
import TermsConditions from "./screens/customer/termsConditions/TermsConditions";
import ReturnPolicy from "./screens/customer/returnPolicy/ReturnPolicy";
import VerifyOtp from "./screens/customer/forgetPassword/Verify_otp";
import ResetPassword from "./screens/customer/forgetPassword/ResetPassword";
import ForgotPassword from "./screens/customer/forgetPassword/ForgetPassword";

const App = () => {
  return (
    <CartProvider>
      <CheckoutProvider>
        <AuthProvider>
          <Routes>
            {/*  GENERAL ROUTES */}
            <Route path="/" element={<LandingPage />} />
            <Route path="/decora-ai" element={<DecorAI />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/checkout" element={<Checkout />} />
            <Route path="/products" element={<ProductListing />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/forget-password" element={<ForgotPassword />} />
            <Route path="/forget-password/verify-otp" element={<VerifyOtp />} />
            <Route
              path="/forget-password/reset-password"
              element={<ResetPassword />}
            />

            <Route
              path="/product/custom-product"
              element={<CustomizationPannel />}
            />
            <Route path="/order-confirmation" element={<OrderConfirmation />} />
            <Route path="/browse-bidding" element={<BrowseBidding />} />
            <Route path="/our-story" element={<FullStory />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="*" element={<NotFound />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/terms-conditions" element={<TermsConditions />} />
            <Route path="/return-policy" element={<ReturnPolicy />} />

            {/* CUSTOMER ROUTES */}
            <Route
              path="/customer/*"
              element={
                <CustomerMasterLayout>
                  <Routes>
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/orders" element={<Orders />} />
                    {/* <Route path="/custom-requests" element={<CustomRequests />} /> */}
                    <Route path="/order-details" element={<OrderDetails />} />
                    <Route
                      path="/custom-requests"
                      element={<CustomRequests />}
                    />
                    <Route
                      path="/custom-requests/:id"
                      element={<CustomOrderDetail />}
                    />
                    <Route path="/orders/:id" element={<OrderDetails />} />
                    <Route path="/wishlist" element={<Wishlist />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/notifications" element={<Notifications />} />
                    <Route path="/help-support" element={<HelpSupport />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/logout" element={<Logout />} />
                    <Route
                      path="/my-tickets"
                      element={
                        <ProtectedRoute>{/* <MyTickets /> */}</ProtectedRoute>
                      }
                    />
                    {/* <Route path="customer/orders-view" element={<OrderView />} /> */}
                    {/* <Route path="/my-biddings" element={<MyBiddings />} /> */}
                    {/* <Route path="/my-bids" element={<MyBids />} /> */}
                    <Route
                      path="/help-support/chat/:ticketId"
                      element={<TicketChat />}
                    />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/logout" element={<Logout />} />
                    {/* <Route
                        path="customer/orders-view"
                        element={<OrderView />}
                      /> */}
                    <Route
                      path="/bidding-activity"
                      element={<BiddingActivity />}
                    />
                  </Routes>
                </CustomerMasterLayout>
              }
            />

            {/* ADMIN ROUTES */}
            <Route path="/admin-login" element={<AdminLogin />} />
            <Route path="/side-bar" element={<AdminSidebar />} />
            <Route
              path="/admin/*"
              element={
                <AdminMasterLayout>
                  <Routes>
                    <Route path="dashboard" element={<AdminDashboard />} />
                    <Route path="product-list" element={<AdminProductList />} />
                    <Route
                      path="/product-list/:id"
                      element={<AdminProductView />}
                    />
                    <Route path="/order-list" element={<AdminOrdersList />} />
                    <Route
                      path="/order-list/:id"
                      element={<AdminOrderView />}
                    />
                    <Route
                      path="/custom-orders"
                      element={<AdminCustomOrderList />}
                    />
                    <Route
                      path="/custom-orders/:id"
                      element={<AdminCustomOrderDetail />}
                    />
                    <Route
                      path="/category-list"
                      element={<AdminCategoryList />}
                    />

                    <Route path="/coupon-list" element={<AdminCouponList />} />

                    <Route path="/customers" element={<CustomerList />} />
                    <Route path="/customers/:id" element={<CustomerDetail />} />
                    <Route
                      path="/Inventory/materials"
                      element={<RawMaterialList />}
                    />
                    <Route path="/stock-alerts" element={<StockAlerts />} />
                    <Route path="/stock-history" element={<StockHistory />} />
                    <Route
                      path="/bidding-list"
                      element={<BiddingManagement />}
                    />
                    <Route path="/faq" element={<AdminFAQ />} />
                    <Route
                      path="/notifications"
                      element={<AdminNotifications />}
                    />
                    <Route
                      path="/help-support"
                      element={<AdminHelp_Support />}
                    />

                    <Route path="/settings" element={<AdminSettings />} />
                  </Routes>
                </AdminMasterLayout>
              }
            />
          </Routes>
        </AuthProvider>
      </CheckoutProvider>
    </CartProvider>
  );
};

export default App;
